module.exports = __webpack_public_path__ + "static/img/2.d100390.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/2.jpg
// module id = i/H9
// module chunks = 25